import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useEmailInboxPreview } from "./use-email-inbox-preview";
import { EmailInboxDetails } from "./email-inbox-details";

type EmailInboxDialogProps = {
  archiveId?: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

/* Mounted only while the dialog is open, so the API is called on open */
const EmailInboxDialogBody = ({ archiveId }: { archiveId?: string }) => {
  const { emailInbox, loading } = useEmailInboxPreview(archiveId);
  return (
    <EmailInboxDetails
      emailInbox={emailInbox}
      loading={loading}
      contentClassName="md:h-auto max-h-[calc(100dvh-160px)]"
    />
  );
};

export const EmailInboxDialog = ({
  archiveId,
  open,
  onOpenChange,
}: EmailInboxDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl w-[calc(100vw-32px)] gap-3">
        <DialogHeader>
          <DialogTitle>Email Inbox</DialogTitle>
          <DialogDescription className="sr-only">
            Email inbox details
          </DialogDescription>
        </DialogHeader>
        {open ? <EmailInboxDialogBody archiveId={archiveId} /> : null}
      </DialogContent>
    </Dialog>
  );
};
